import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function LoadingBackdrop({ open }: { open: boolean }) {
  return (
    <Backdrop
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: "#fff" }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
